import { render, staticRenderFns } from "./CreateNewWidgetButton.vue?vue&type=template&id=3e202804&"
import script from "./CreateNewWidgetButton.vue?vue&type=script&lang=js&"
export * from "./CreateNewWidgetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports